export default {
    mounted: function(el, binding) {
        
        let field = binding.instance?.field
        
        // Safety guard in case the component instance doesn't have a field property yet
        if (!field) return
        
        // Do not enable auto-grow if the textarea is set with a rows attribute.
        if (
            field
            && field.rows !== ''
            && field.rows > 0
        ) {
            return false
        }
        
        setHeight()
        el.oninput = setHeight
        
        function setHeight() {
            el.style.height = ''
            
            // If the field is empty its scroll height will be zero.
            let h = el.scrollHeight
            if (h) {
                el.style.height = h + 'px'
            }
        }
    },
}